import script from "./AdminLocationItems.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLocationItems.vue?vue&type=script&setup=true&lang=js"

import "./AdminLocationItems.vue?vue&type=style&index=0&id=5b9f31cf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9f31cf"]])

export default __exports__